module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/10-2432c88f87abc5940aeeb05bb4424c52.svg";